import types from './types';

const fetchState = (data) => ({
  type: types.FETCH_STATE,
  data,
});

const setState = (data) => ({
  type: types.SET_STATE,
  data,
});

const updatePlayerState = (data) => ({
  type: types.UPDATE_PLAYER_STATE,
  data,
});

export default {
  fetchState,
  setState,
  updatePlayerState,
};
